import { Component, inject, OnInit, signal, } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { FieldsetModule } from 'primeng/fieldset';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { ToolsService } from '../../../tools/services/tools.service';
import { ToolsDto } from '../../../tools/dtos/tools.dto';
import { DeeplinkService } from '../../services/deeplink.service';

@Component({
  selector: 'app-select-tool',
  standalone: true,
  imports: [
      TableModule,
      FieldsetModule,
      TooltipModule,
      ButtonModule,
      MessageModule,
      RouterModule
  ],
  providers: [ToolsService,DeeplinkService],
  templateUrl: './select-tool.html'
})
export class SelectToolComponent implements OnInit {

  loading = signal<boolean>(false);
  tools:Array<ToolsDto> = new Array<ToolsDto>()
  toolsService = inject(ToolsService)
  deeplinkingService = inject(DeeplinkService)
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  courseCode!: string;
  selectedTool!:ToolsDto
  first: number = 0;
  rows: number = 10;
  totalRecords = signal<number>(0);
  sortField = 'name';
  sortOrder = 'ASC';


  ngOnInit() {
    this.courseCode = this.route.snapshot.paramMap.get('courseCode') as string;
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.loadTools({ 
      skip: event.first ?? 0,
      limit: event.rows ?? 10,
      sortField: event.sortField as string ?? 'name',
      sortOrder: event.sortOrder === 1 ? 'ASC' : 'DESC' });
  }
  async loadTools({skip,limit,sortField,sortOrder}:{skip:number,limit:number,sortField:string,sortOrder:string}){
    this.loading.set(true);
    const response = await this.toolsService.getTools({skip,limit,sortField,sortOrder});
    this.tools = response.data
    this.totalRecords.set(response.total);
    this.loading.set(false);
  }
  initiateDeeplinking(toolId:string){
    this.router.navigate(['/deeplink-launch', toolId, this.courseCode]);
  }
}
